import { useLanguage } from '../lib/i18n/LanguageContext';

/**
 * The EN/TH switch, sitting next to ThemeToggle wherever that appears. Same
 * persistence story as theme — see src/lib/i18n/LanguageContext.tsx.
 *
 * A segmented pair rather than a single toggle: language names are not a
 * binary "on/off" the way light/dark is, and showing both options at once
 * means the customer never has to guess what one click will switch *to*.
 */
export function LanguageSwitcher() {
  const { locale, dict, setLocale } = useLanguage();
  return (
    <div className="lang-switch" role="group" aria-label={`${dict.languageSwitcher.english} / ${dict.languageSwitcher.thai}`}>
      <button
        type="button"
        className={`lang-switch-option${locale === 'en' ? ' is-active' : ''}`}
        aria-pressed={locale === 'en'}
        aria-label={dict.languageSwitcher.switchToEnglish}
        title={dict.languageSwitcher.switchToEnglish}
        onClick={() => setLocale('en')}
      >
        {dict.languageSwitcher.english}
      </button>
      <button
        type="button"
        className={`lang-switch-option${locale === 'th' ? ' is-active' : ''}`}
        aria-pressed={locale === 'th'}
        aria-label={dict.languageSwitcher.switchToThai}
        title={dict.languageSwitcher.switchToThai}
        onClick={() => setLocale('th')}
      >
        {dict.languageSwitcher.thai}
      </button>
    </div>
  );
}
